<!-- body starts-->
<section class="body-wrapper" [ngClass]="{ 'homepage' : homepage, 'loginpage' : loginpage, 'registerpage' : registerpage, 'addresspage' : addresspage, 'membershippage' : membershippage, 'evnetsinglepage' : evnetsinglepage, 'membershipsinglepage' :membershipsinglepage, 'confirmationpage' :confirmationpage, 'matchticketspage' :matchticketspage, 'forgotpage' :forgotpage , 'evnetgracesinglepage' :evnetgracesinglepage }">
  <div class="header-main" [ngClass]="{ 'noshow' : hide_ad }" *ngIf="footerSponsors">
    <a href="{{footerSponsors?.redirect_url}}" target="_blank" *ngIf="footerSponsors?.image">
      <img [src]="footerSponsors?.image" class="desk-img">
    </a>
    <a href="{{footerSponsors?.redirect_url}}" target="_blank" *ngIf="footerSponsors?.mobile_image">
      <img [src]="footerSponsors?.mobile_image" class="mobile-img">
    </a>
    <div class="header-main-cross-icon" *ngIf="footerSponsors">
        <a href="javascript:void(0);" (click)="toggleAd()" > <img src="assets/images/close-icon.svg"></a>
    </div>
  </div>
  <header class="header-wrapper sticky-header">
    
    <div class="header-top-section cf">
      <div class="header-dsk-menu">
        <div class="header-top-menu cf">
          <div class="header-top-left">
            <div class="header-top-menu-left-humburger">
              <div class="enumenu_container"><div class="menu-icon"> <div class="menu-box"><span></span><span></span> </div></div>
              </div>
            </div>
            <div class="header-top-logo">
               <a href="#" title="logo"> <img src="assets/images/lcclogo.svg" alt="lcclogo"></a>
            </div>
            <div class="header-top-menu-list">
              <ul>
                <li><a href="/membership">Membership</a></li>
                <li><a href="/event/whats-on/events">Events</a></li>
                <li><a href="/hospitality">Corporate</a></li>
                
                <li><a href="https://lccc-shop.com/" target="_blank">Shop</a></li>      
                <li><a href="/event/conference-and-events/corporate-days">VENUE HIRE </a></li>                 
              </ul>
            </div>
          </div>
          <div class="header-top-right">
             <!-- <form>
                <div class="header-search-box">
                  <input type="text" placeholder="Enter your email">
                  <button><img src="assets/images/right-arrows-header.svg" alt="right-arrows-header"></button>
                </div>
             </form> -->
             <form class="signupform " #subscriptionForm="ngForm" (ngSubmit)="doSubscription(subscriptionForm)">
              <http-message types="success" [data]="subscriptionSuccess" class="err-msg-block"></http-message>
              <http-message [type]="'error'" [data]="subscriptionError" *ngIf="subscriptionError" class="err-msg-block"></http-message>
							<div class="header-search-box">
                <app-form-field validation="required" name="email" [(ngModel)]="subscriptionRequest.email" class="app-group">
                  <input appFieldInput class="register-style" placeholder="Join our mailing list " type="text">
                  <button id="reg_button" type="submit"><img src="assets/images/right-arrows-header.svg" alt="right-arrows-header"></button>
                </app-form-field>
                
              </div>              
						</form>
             <!-- <ul>
                <li>
                  <a href="#">
                    <svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="16.334" cy="16" r="16" fill="#418940"/>
                      <path d="M17.6673 17.625H19.5721L20.334 14.625H17.6673V13.125C17.6673 12.3525 17.6673 11.625 19.1911 11.625H20.334V9.105C20.0856 9.07275 19.1477 9 18.1572 9C16.0887 9 14.6197 10.2427 14.6197 12.525V14.625H12.334V17.625H14.6197V24H17.6673V17.625Z" fill="white"/>
                    </svg>                      
                  </a>
                </li>
                <li>
                  <a href="#">
                    <svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="16.334" cy="16" r="16" fill="#418940"/>
                      <path d="M23.334 12.2941C22.8187 12.5206 22.2632 12.6694 21.6877 12.7406C22.2766 12.3976 22.7317 11.8541 22.9458 11.2006C22.3904 11.5241 21.7747 11.7506 21.1256 11.88C20.5969 11.3235 19.8541 11 19.0108 11C17.4382 11 16.1533 12.2424 16.1533 13.7759C16.1533 13.9959 16.1801 14.2094 16.2269 14.41C13.8445 14.2935 11.7231 13.1871 10.311 11.5112C10.0634 11.9188 9.92289 12.3976 9.92289 12.9024C9.92289 13.8665 10.4248 14.7206 11.2011 15.2059C10.726 15.2059 10.2843 15.0765 9.89613 14.8824V14.9018C9.89613 16.2476 10.8866 17.3735 12.1982 17.6259C11.7771 17.7373 11.335 17.7528 10.9066 17.6712C11.0884 18.2228 11.4444 18.7054 11.9245 19.0513C12.4047 19.3972 12.9849 19.5889 13.5835 19.5994C12.5687 20.3762 11.3108 20.796 10.0166 20.79C9.78905 20.79 9.56152 20.7771 9.33398 20.7512C10.6055 21.5406 12.1179 22 13.7374 22C19.0108 22 21.9086 17.7682 21.9086 14.0994C21.9086 13.9765 21.9086 13.86 21.9019 13.7371C22.464 13.3488 22.9458 12.8571 23.334 12.2941Z" fill="white"/>
                    </svg>                      
                  </a>
                </li>
                <li>
                  <a href="#">
                    <svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="16.334" cy="16" r="16" fill="#418940"/>
                      <path d="M16.334 9C18.2359 9 18.4732 9.007 19.2194 9.042C19.9649 9.077 20.4724 9.1939 20.919 9.3675C21.381 9.5453 21.7702 9.7861 22.1594 10.1746C22.5153 10.5245 22.7908 10.9478 22.9665 11.415C23.1394 11.8609 23.257 12.3691 23.292 13.1146C23.3249 13.8608 23.334 14.0981 23.334 16C23.334 17.9019 23.327 18.1392 23.292 18.8854C23.257 19.6309 23.1394 20.1384 22.9665 20.585C22.7913 21.0524 22.5158 21.4758 22.1594 21.8254C21.8094 22.1812 21.3861 22.4566 20.919 22.6325C20.4731 22.8054 19.9649 22.923 19.2194 22.958C18.4732 22.9909 18.2359 23 16.334 23C14.4321 23 14.1948 22.993 13.4486 22.958C12.7031 22.923 12.1956 22.8054 11.749 22.6325C11.2816 22.4571 10.8583 22.1817 10.5086 21.8254C10.1526 21.4755 9.87714 21.0522 9.70148 20.585C9.52788 20.1391 9.41098 19.6309 9.37598 18.8854C9.34308 18.1392 9.33398 17.9019 9.33398 16C9.33398 14.0981 9.34098 13.8608 9.37598 13.1146C9.41098 12.3684 9.52788 11.8616 9.70148 11.415C9.87665 10.9475 10.1521 10.5241 10.5086 10.1746C10.8584 9.81846 11.2817 9.54301 11.749 9.3675C12.1956 9.1939 12.7024 9.077 13.4486 9.042C14.1948 9.0091 14.4321 9 16.334 9ZM16.334 12.5C15.4057 12.5 14.5155 12.8687 13.8591 13.5251C13.2027 14.1815 12.834 15.0717 12.834 16C12.834 16.9283 13.2027 17.8185 13.8591 18.4749C14.5155 19.1313 15.4057 19.5 16.334 19.5C17.2622 19.5 18.1525 19.1313 18.8089 18.4749C19.4652 17.8185 19.834 16.9283 19.834 16C19.834 15.0717 19.4652 14.1815 18.8089 13.5251C18.1525 12.8687 17.2622 12.5 16.334 12.5ZM20.884 12.325C20.884 12.0929 20.7918 11.8704 20.6277 11.7063C20.4636 11.5422 20.241 11.45 20.009 11.45C19.7769 11.45 19.5544 11.5422 19.3903 11.7063C19.2262 11.8704 19.134 12.0929 19.134 12.325C19.134 12.5571 19.2262 12.7796 19.3903 12.9437C19.5544 13.1078 19.7769 13.2 20.009 13.2C20.241 13.2 20.4636 13.1078 20.6277 12.9437C20.7918 12.7796 20.884 12.5571 20.884 12.325ZM16.334 13.9C16.8909 13.9 17.4251 14.1212 17.8189 14.5151C18.2127 14.9089 18.434 15.443 18.434 16C18.434 16.557 18.2127 17.0911 17.8189 17.4849C17.4251 17.8788 16.8909 18.1 16.334 18.1C15.777 18.1 15.2429 17.8788 14.8491 17.4849C14.4552 17.0911 14.234 16.557 14.234 16C14.234 15.443 14.4552 14.9089 14.8491 14.5151C15.2429 14.1212 15.777 13.9 16.334 13.9Z" fill="white"/>
                    </svg>                      
                  </a>
                </li>
                <li>
                  <a href="#">
                    <svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="16.334" cy="16" r="16" fill="#418940"/>
                      <path d="M20.6478 11.35C20.6478 11.35 21.0706 11.7667 20.6478 11.35C20.081 10.6997 19.7687 9.86453 19.7689 9H17.2071V19.3333C17.1873 19.8925 16.9524 20.4222 16.5519 20.8108C16.1514 21.1994 15.6164 21.4166 15.0597 21.4167C13.8825 21.4167 12.9041 20.45 12.9041 19.25C12.9041 17.8167 14.2804 16.7417 15.6981 17.1833V14.55C12.8378 14.1667 10.334 16.4 10.334 19.25C10.334 22.025 12.6223 24 15.0515 24C17.6548 24 19.7689 21.875 19.7689 19.25V14.0083C20.8078 14.7582 22.055 15.1605 23.334 15.1583V12.5833C23.334 12.5833 21.7753 12.6583 20.6478 11.35Z" fill="white"/>
                    </svg>                      
                  </a>
                </li>
                <li>
                  <a href="#">
                    <svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="16.334" cy="16" r="16" fill="#418940"/>
                      <path d="M12.1414 22.8193C11.7463 23.0465 11.3461 23.0595 10.9408 22.8581C10.5363 22.6574 10.334 22.3473 10.334 21.9278V11.0725C10.334 10.653 10.5363 10.3425 10.9408 10.1412C11.3461 9.94049 11.7463 9.95377 12.1414 10.181L21.8007 15.6087C22.1562 15.8184 22.334 16.1156 22.334 16.5001C22.334 16.8847 22.1562 17.1819 21.8007 17.3916L12.1414 22.8193Z" fill="white"/>
                    </svg>                      
                  </a>
                </li>
                <li>
                  <a href="#">
                    <svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="16.334" cy="16" r="16" fill="#418940"/>
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M14.5343 13.8783H17.1341V15.1733C17.5086 14.4285 18.469 13.7593 19.9117 13.7593C22.6774 13.7593 23.334 15.2419 23.334 17.9621V23H20.534V18.5816C20.534 17.0325 20.1595 16.1589 19.2061 16.1589C17.8838 16.1589 17.3343 17.1004 17.3343 18.5809V23H14.5343V13.8783ZM9.73298 22.881H12.533V13.7593H9.73298V22.881ZM12.9341 10.785C12.9342 11.0197 12.8876 11.2521 12.7972 11.4686C12.7067 11.6852 12.574 11.8816 12.407 12.0464C12.0685 12.3828 11.6103 12.5712 11.133 12.57C10.6566 12.5697 10.1994 12.3818 9.86038 12.0471C9.69393 11.8817 9.56175 11.6851 9.47142 11.4685C9.3811 11.2519 9.33439 11.0197 9.33398 10.785C9.33398 10.3111 9.52298 9.8575 9.86108 9.5229C10.1998 9.18771 10.6572 8.99979 11.1337 9C11.6111 9 12.0689 9.1883 12.407 9.5229C12.7444 9.8575 12.9341 10.3111 12.9341 10.785Z" fill="white"/>
                    </svg>                      
                  </a>
                </li>
             </ul> -->
             <div class="popup-match-icon mobile-match">
                <ul>
                  <li class="bat-boll"><a href="javascript:void(0);"><img src="assets/images/bat-boll.svg" alt="bat-boll"></a></li>
                  <li class="close-popup"><a href="javascript:void(0);"><img src="assets/images/close-icon.svg" alt="close-icon"></a></li>
                  <!-- <li><a href="javascript:void(0);">Match centre</a></li> -->
                </ul>
              </div>
              <div class="popup-match mobile-match">
                <div class="popup-match-detail">
                  <div class="popup-match-detail-inner live-box" *ngIf="livematcheList?.data?.length > 0">
                    <div class="popup-match-live">
                      <p>live</p>
                    </div>
                    <div class="popup-match-live-score">
                      
                        <div class="popup-match-live-score-box">
                          <div class="match-live-score-box">
                            <div class="match-live-image">
                              <img [src]="livematchesList?.first_image" alt="Bitmap-one">
                            </div>
                          </div>
                          <div class="match-live-vs">
                            <h4>vs</h4>
                          </div>
                          <div class="match-live-score-box">
                            <div class="match-live-image">
                              <img [src]="livematchesList?.second_image" alt="Bitmap">
                            </div>
                          </div>
                        </div>
                      
                    </div>
                    <div class="popup-match-live-text-btn">
                      <div class="popup-matchcenter-btn orange-btn">
                        <a [routerLink]="['/livescore', livematchesList?.matchid]" *ngIf="livematchesList?.matchid">matchcentre</a>
                      </div>
                    </div>
                  </div>
                  <div class="popup-match-detail-inner upcoming-box" *ngIf="livematcheList?.data?.length == 0">
                    <div class="fixture-results-upcoming-box">
                      <div class="fixture-results-upcoming-top">
                        <div class="fixture-results-upcoming-ticket">
                          <a href="{{homeupcomingList?.redirect_url}}" target="_blank" *ngIf="homeupcomingList?.redirect_url"><img src="assets/images/ticket-logo.png" alt="ticket-logo"></a>
                        </div>
                      </div>
                      <div class="fixture-results-upcoming-bottom">
                        <div class="fixture-results-upcoming-match-team">
                          <div class="fixture-results-upcoming-team">
                            <div class="upcoming-team-box">
                              <img [src]="homeupcomingList?.first_image" alt="{{homeupcomingList?.first_name}}">
                            </div>
                          </div>
                          <div class="fixture-results-upcoming-vs">
                            <h4>VS</h4>
                          </div>
                          <div class="fixture-results-upcoming-team">
                            <img [src]="homeupcomingList?.second_image" alt="{{homeupcomingList?.second_name}}">
                          </div>
                        </div>
                        <div class="upcoming-match-all-detail">
                          <!-- <div class="upcoming-match-all-detail-box">
                            <p>Upcoming Match</p>
                            <h4>{{homeupcomingList?.date_time | amDateFormat: "DD MMM YYYY h:mm A z"}}</h4>
                          </div> -->
                          <div class="upcoming-match-all-detail-box">
                            <h4>{{homeupcomingList?.location}}</h4>
                          </div>
                        </div>
                        <div class="orange-btn">
                          <a routerLink="/fixtures">view all</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
          </div>
        </div>
        <div class="header-bottom-menu cf">
          <div class="header-bottom-left">
            <ul>
              <li>
                <a href="#"  class="arrows-down">Tickets</a>
                <div class="mega-menu-hover">
                  <div class="mega-menu-list-box">
                    <div class="mega-menu-list-box-inner" style="background-image:url(assets/images/match-tickets.png); background-repeat: no-repeat; ">
                      <div class="mega-menu-list-box-overlay">
                          <h3>match tickets</h3>
                          <div class="mega-menu-list-box-btn">
                             <a href="https://www.tixr.com/groups/leicestershire-ccc" target="_blank">BUY TICKETS </a>
                             
                          </div>
                      </div>
                    </div>
                  </div>
                  <div class="mega-menu-list-box">
                    <div class="mega-menu-list-box-inner" style="background-image:url(assets/images/premium-hospitality.png); background-repeat: no-repeat; ">
                      <div class="mega-menu-list-box-overlay">
                          <h3>premium & hospitality</h3>
                          <div class="mega-menu-list-box-btn">
                             <a href="https://leicestershireccchospitality.seatunique.com/" target="_blank"> BUY HOSPITALITY </a>
                          </div>
                      </div>
                    </div>
                  </div>
                  <div class="mega-menu-list-box">
                    <div class="mega-menu-list-box-inner" style="background-image:url(assets/images/events.png); background-repeat: no-repeat; ">
                      <div class="mega-menu-list-box-overlay">
                          <h3>events</h3>
                          <div class="mega-menu-list-box-btn">
                             <a href="/event/whats-on/events">VIEW MORE </a>
                          </div>
                      </div>
                    </div>
                  </div>
                  <div class="mega-menu-list-box">
                    <div class="mega-menu-list-box-inner" style="background-image:url(assets/images/faqs.png); background-repeat: no-repeat; ">
                      <div class="mega-menu-list-box-overlay">
                          <h3>faq’s</h3>
                          <div class="mega-menu-list-box-btn">
                             <a href="/faqs">VIEW MORE </a>
                          </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
              <li>
                <a href="#" class="arrows-down">Squads</a>
                <div class="mega-menu-hover">
                  <div class="mega-menu-list-box">
                    <div class="mega-menu-list-box-inner" style="background-image:url(assets/images/first-team.jpg); background-repeat: no-repeat; ">
                      <div class="mega-menu-list-box-overlay">
                          <h3>First Team</h3>
                          <div class="mega-menu-list-box-btn">
                             <a href="/player">VIEW MORE </a>
                          </div>
                      </div>
                    </div>
                  </div>
                  <div class="mega-menu-list-box">
                    <div class="mega-menu-list-box-inner" style="background-image:url(assets/images/coaching-staff.png); background-repeat: no-repeat; ">
                      <div class="mega-menu-list-box-overlay">
                          <h3>Coaching Staff</h3>
                          <div class="mega-menu-list-box-btn">
                             <a href="/player">VIEW MORE </a>
                          </div>
                      </div>
                    </div>
                  </div>
                  <div class="mega-menu-list-box">
                    <div class="mega-menu-list-box-inner" style="background-image:url(assets/images/womens-team-new.jpg); background-repeat: no-repeat; ">
                      <div class="mega-menu-list-box-overlay">
                          <h3>Women’s Team</h3>
                          <div class="mega-menu-list-box-btn">
                             <a href="/player">VIEW MORE </a>
                          </div>
                      </div>
                    </div>
                  </div>
                  <div class="mega-menu-list-box">
                    <div class="mega-menu-list-box-inner" style="background-image:url(assets/images/academy-team.png); background-repeat: no-repeat; ">
                      <div class="mega-menu-list-box-overlay">
                          <h3>academy team</h3>
                          <div class="mega-menu-list-box-btn">
                             <a href="https://www.leicestershireccc.co.uk/academy">VIEW MORE </a>
                          </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
              <li>
                <a href="#" class="arrows-down">Matches</a>
                <div class="mega-menu-hover">
                  <div class="mega-menu-list-box">
                    <div class="mega-menu-list-box-inner" style="background-image:url(assets/images/first-xi-fixtures.jpg); background-repeat: no-repeat; ">
                      <div class="mega-menu-list-box-overlay">
                          <h3>First xi fixtures</h3>
                          <div class="mega-menu-list-box-btn">
                             <a href="/fixtures">VIEW MORE </a>
                          </div>
                      </div>
                    </div>
                  </div>
                  <div class="mega-menu-list-box">
                    <div class="mega-menu-list-box-inner" style="background-image:url(assets/images/second-fixtures-new.jpg); background-repeat: no-repeat; ">
                      <div class="mega-menu-list-box-overlay">
                          <h3>second xi fixtures</h3>
                          <div class="mega-menu-list-box-btn">
                             <a href="/fixtures">VIEW MORE </a>
                          </div>
                      </div>
                    </div>
                  </div>
                  <div class="mega-menu-list-box">
                    <div class="mega-menu-list-box-inner" style="background-image:url(assets/images/womens-fixtures-new.jpg); background-repeat: no-repeat; ">
                      <div class="mega-menu-list-box-overlay">
                          <h3>Women’s fixtures</h3>
                          <div class="mega-menu-list-box-btn">
                             <a href="/fixtures">VIEW MORE </a>
                          </div>
                      </div>
                    </div>
                  </div>
                  <div class="mega-menu-list-box">
                    <div class="mega-menu-list-box-inner" style="background-image:url(assets/images/international.png); background-repeat: no-repeat; ">
                      <div class="mega-menu-list-box-overlay">
                          <h3>international</h3>
                          <div class="mega-menu-list-box-btn">
                             <a href="/fixtures">VIEW MORE </a>
                          </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
              <li><a routerLink="/news">News</a></li>
              <li><a href="/videos">Foxes tv</a></li>
              <li>
                <a href="/foundation/news" class="arrows-down">Foundation</a>
                <div class="mega-menu-hover">
                  <div class="mega-menu-list-box">
                    <div class="mega-menu-list-box-inner" style="background-image:url(assets/images/community.png); background-repeat: no-repeat; ">
                      <div class="mega-menu-list-box-overlay">
                          <h3>Community</h3>
                          <div class="mega-menu-list-box-btn">
                             <a href="/foundation/communitys">VIEW MORE </a>
                          </div>
                      </div>
                    </div>
                  </div>
                  <div class="mega-menu-list-box">
                    <div class="mega-menu-list-box-inner" style="background-image:url(assets/images/club-and-leagues.png); background-repeat: no-repeat; ">
                      <div class="mega-menu-list-box-overlay">
                          <h3>Clubs and Leagues</h3>
                          <div class="mega-menu-list-box-btn">
                             <a href="/foundation/clubs">VIEW MORE </a>
                          </div>
                      </div>
                    </div>
                  </div>
                  <div class="mega-menu-list-box">
                    <div class="mega-menu-list-box-inner" style="background-image:url(assets/images/women-and-girls.png); background-repeat: no-repeat; ">
                      <div class="mega-menu-list-box-overlay">
                          <h3>Women’s and girls</h3>
                          <div class="mega-menu-list-box-btn">
                             <a href="/foundation/women-and-girls">VIEW MORE </a>
                          </div>
                      </div>
                    </div>
                  </div>
                  <div class="mega-menu-list-box">
                    <div class="mega-menu-list-box-inner" style="background-image:url(assets/images/community-and-school.png); background-repeat: no-repeat; ">
                      <div class="mega-menu-list-box-overlay">
                          <h3>School Programmes</h3>
                          <div class="mega-menu-list-box-btn">
                             <a href="/foundation/schools">VIEW MORE </a>
                          </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
              <li>
                <a href="/club/about" class="arrows-down">Club</a>
                <div class="mega-menu-hover">
                  <div class="mega-menu-list-box">
                    <div class="mega-menu-list-box-inner" style="background-image:url(assets/images/about-club.png); background-repeat: no-repeat; ">
                      <div class="mega-menu-list-box-overlay">
                          <h3>about the club</h3>
                          <div class="mega-menu-list-box-btn">
                             <a href="/club/about">VIEW MORE </a>
                          </div>
                      </div>
                    </div>
                  </div>
                  <div class="mega-menu-list-box">
                    <div class="mega-menu-list-box-inner" style="background-image:url(assets/images/our-rich.png); background-repeat: no-repeat; ">
                      <div class="mega-menu-list-box-overlay">
                          <h3>our rich history</h3>
                          <div class="mega-menu-list-box-btn">
                             <a href="/club/history">VIEW MORE </a>
                          </div>
                      </div>
                    </div>
                  </div>
                  <div class="mega-menu-list-box">
                    <div class="mega-menu-list-box-inner" style="background-image:url(assets/images/uponsteel-county-ground.png); background-repeat: no-repeat; ">
                      <div class="mega-menu-list-box-overlay">
                          <h3>Uptonsteel County Ground</h3>
                          <div class="mega-menu-list-box-btn">
                             <a href="/club/premier-outdoor-venue">VIEW MORE </a>
                          </div>
                      </div>
                    </div>
                  </div>
                  <div class="mega-menu-list-box">
                       <ul>
                          <li><a href="/club/governance">governance</a></li>
                          <li><a href="/recruitment">Recruitment</a></li>
                          <li><a href="/club/safeguarding">safeguarding</a></li>
                          <li><a href="/club/friends-of-grace-road">friends of grace road</a></li>
                          <li><a href="/contact">contact us</a></li>                       
                       </ul>
                  </div>
                </div>
              </li>                                                                           
            </ul>
          </div>
          
          <div class="header-bottom-right">
            <div class="popup-match-icon dsk-match">
              <ul>
                <li class="bat-boll"><a href="javascript:void(0);"><img src="assets/images/bat-boll.svg" alt="bat-boll"> Match centre</a></li>
                <li class="close-popup"><a href="javascript:void(0);"><img src="assets/images/close-icon.svg" alt="close-icon"> Match centre</a></li>
                <!-- <li><a href="javascript:void(0);">Match centre</a></li> -->
              </ul>
            </div>
            <div class="popup-match">
              <div class="popup-match-detail">
                <div class="popup-match-detail-inner live-box" *ngIf="livematcheList?.data?.length > 0">
                  <div class="popup-match-live">
                    <p>live</p>
                  </div>
                  <div class="popup-match-live-score">
                    
                      <div class="popup-match-live-score-box">
                        <div class="match-live-score-box">
                          <div class="match-live-image">
                            <img [src]="livematchesList?.first_image" alt="Bitmap-one">
                          </div>
                        </div>
                        <div class="match-live-vs">
                          <h4>vs</h4>
                        </div>
                        <div class="match-live-score-box">
                          <div class="match-live-image">
                            <img [src]="livematchesList?.second_image" alt="Bitmap">
                          </div>
                        </div>
                      </div>
                    
                  </div>
                  <div class="popup-match-live-text-btn">
                    <div class="popup-matchcenter-btn orange-btn">
                      <a [routerLink]="['/livescore', livematchesList?.matchid]" *ngIf="livematchesList?.matchid">matchcentre</a>
                    </div>
                  </div>
                </div>
                <div class="popup-match-detail-inner upcoming-box" *ngIf="livematcheList?.data?.length == 0">
                  <div class="fixture-results-upcoming-box">
                    <div class="fixture-results-upcoming-top">
                      <div class="fixture-results-upcoming-ticket">
                        <a href="{{homeupcomingList?.redirect_url}}" target="_blank" *ngIf="homeupcomingList?.redirect_url"><img src="assets/images/ticket-logo.png" alt="ticket-logo"></a>
                      </div>
                    </div>
                    <div class="fixture-results-upcoming-bottom">
                      <div class="fixture-results-upcoming-match-team">
                        <div class="fixture-results-upcoming-team">
                          <div class="upcoming-team-box">
                            <img [src]="homeupcomingList?.first_image" alt="{{homeupcomingList?.first_name}}">
                          </div>
                        </div>
                        <div class="fixture-results-upcoming-vs">
                          <h4>VS</h4>
                        </div>
                        <div class="fixture-results-upcoming-team">
                          <img [src]="homeupcomingList?.second_image" alt="{{homeupcomingList?.second_name}}">
                        </div>
                      </div>
                      <div class="upcoming-match-all-detail">
                        <!-- <div class="upcoming-match-all-detail-box">
                          <p>Upcoming Match</p>
                          <h4>{{homeupcomingList?.date_time | amDateFormat: "DD MMM YYYY h:mm A z"}}</h4>
                        </div> -->
                        <div class="upcoming-match-all-detail-box">
                          <h4>{{homeupcomingList?.location}}</h4>
                        </div>
                      </div>
                      <div class="orange-btn">
                        <a routerLink="/fixtures">view all</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <ul class="buy-tickets-header">
              <li><a href="https://www.tixr.com/groups/leicestershire-ccc"  target="_blank" title="buyticket-icon"><img src="assets/images/buy-ticket-icon-header.svg" alt="buy-ticket-icon-header"></a></li>
              <li><a href="https://www.tixr.com/groups/leicestershire-ccc"  target="_blank" title="buyticket-icon">Buy Tickets</a></li>
            </ul>
            <!-- <ul class="get-our-app-header">
              <li><a href="https://apps.apple.com/us/app/lccc/id1622036879" target="_blank" title="apple-icon"><img src="assets/images/apple-icon-header.svg" alt="apple-icon-heade"></a></li>
              <li><a href="https://play.google.com/store/apps/details?id=com.lccc&gl=GB&pli=1"  target="_blank" title="app-icon"><img src="assets/images/app-icon-header.svg" alt="app-icon-header"></a></li>
              <li>foxes fan app</li>
            </ul> -->
          </div>
        </div>
      </div>
      
      <div class="header-mobile-menu">
        <div class="header-top-right mobile-signup">
          <form class="signupform " #subscriptionForm="ngForm" (ngSubmit)="doSubscription(subscriptionForm)">
           <http-message types="success" [data]="subscriptionSuccess" class="err-msg-block"></http-message>
           <http-message [type]="'error'" [data]="subscriptionError" *ngIf="subscriptionError" class="err-msg-block"></http-message>
           <div class="header-search-box">
             <app-form-field validation="required" name="email" [(ngModel)]="subscriptionRequest.email" class="app-group">
               <input appFieldInput class="register-style" placeholder="Enter your email" type="text">
               <button id="reg_button" type="submit"><img src="assets/images/right-arrows-header.svg" alt="right-arrows-header"></button>
             </app-form-field>
             
           </div>              
         </form>
          
        </div>
        <div class="header-mobile-menu-inner">
           <ul class="menu-mobile-list">
              <li><a href="/membership">Membership</a></li>
              <li><a href="/event/whats-on/events">Events</a></li>
              <li><a href="/hospitality">Corporate</a></li>
              <li><a href="https://lccc-shop.com/" target="_blank">Shop</a></li>    s
              <li><a href="/event/conference-and-events/corporate-days">VENUE HIRE </a></li> 
              <li class="ticket mobile">
                <a href="https://www.eticketing.co.uk/leicestershireccc/" target="_blank"><span class="menu-name">Tickets</span></a><span class="arrow-down"></span>
                <ul class="sub-menu event-submenu">
                  <li><a href="https://www.tixr.com/groups/leicestershire-ccc" target="_blank">match tickets</a></li>
                  <li><a href="https://leicestershireccchospitality.seatunique.com/" target="_blank">premium & hospitality</a></li>
                  <li><a href="/event/whats-on/events">events</a></li>
                  <li><a href="/faqs">faq’s</a></li>
                </ul>
              </li>
              <li class="squads mobile">
                <a href="/player"><span class="menu-name">Squads </span></a><span class="arrow-down"></span>
                <ul class="sub-menu event-submenu">
                  <li><a href="#">First Team</a></li>
                  <li><a href="/player">Coaching Staff</a></li>
                  <li><a href="/player">Women’s Team</a></li>
                  <li><a href="/player">academy team</a></li>
                </ul>
              </li>
              <li class="matches mobile">
                <a href="#"><span class="menu-name">Matches</span></a><span class="arrow-down"></span>
                <ul class="sub-menu event-submenu">
                  <li><a href="/fixtures">First xi fixtures</a></li>
                  <li><a href="#">second xi fixtures</a></li>
                  <li><a href="#">Women’s fixtures</a></li>
                  <li><a href="/register-your-interest-women">international</a></li>
                </ul>
              </li>
              <li><a href="/news">News</a></li> 
              <li><a href="/videos">Foxes tv</a></li> 
              <li class="community mobile">
                <a href="/foundation/news"><span class="menu-name">Foundation</span></a><span class="arrow-down"></span>
                <ul class="sub-menu event-submenu">
                  <li><a href="/foundation/news">Community</a></li>
                  <li><a href="/foundation/clubs">Clubs and Leagues</a></li>
                  <li><a href="/foundation/women-and-girls">Women’s and girls</a></li>
                  <li><a href="/foundation/schools">School Programmes</a></li>
                </ul>
              </li>
              <li class="club mobile">
                <a href="#"><span class="menu-name">Club</span></a><span class="arrow-down"></span>
                <ul class="sub-menu event-submenu">
                  <li><a href="/club/about">about the club</a></li>
                  <li><a href="/club/history">our rich history</a></li>
                  <li><a href="/club/premier-outdoor-venue">Uptonsteel County Ground</a></li>
                  <li><a href="club/governance">governance</a></li>
                  <li><a href="/recruitment">Recruitment</a></li>
                  <li><a href="/club/safeguarding">safeguarding</a></li>
                  <li><a href="/club/friends-of-grace-road">friends of grace road</a></li>
                  <li><a href="/contact">contact us</a></li>
                </ul>
              </li>
           </ul>
            <div class="header-bottom-mobile-main">
              <div class="header-bottom-right">
                <ul class="buy-tickets-header">
                  <li><a href="https://www.eticketing.co.uk/leicestershireccc/"  target="_blank" title="buyticket-icon"><img src="assets/images/buy-ticket-icon-header.svg" alt="buy-ticket-icon-header"></a></li>
                  <li><a href="https://www.eticketing.co.uk/leicestershireccc/"  target="_blank" title="buyticket-icon">Buy Tickets</a></li>
                </ul>
                <!-- <ul class="get-our-app-header">
                  <li><a href="https://apps.apple.com/us/app/lccc/id1622036879" target="_blank" title="apple-icon"><img src="assets/images/apple-icon-header.svg" alt="apple-icon-heade"></a></li>
                  <li><a href="https://play.google.com/store/apps/details?id=com.lccc&gl=GB&pli=1"  target="_blank" title="app-icon"><img src="assets/images/app-icon-header.svg" alt="app-icon-header"></a></li>
                  <li>foxes fan app</li>
                </ul> -->
              </div>
              <div class="mobile-social-icon">
                <ul>
                  <li>
                    <a href="{{settingList?.data?.facebook}}" target="_blank">
                      <svg width="33" height="33" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="16.334" cy="16" r="16" fill="#418940"/>
                        <path d="M17.6673 17.625H19.5721L20.334 14.625H17.6673V13.125C17.6673 12.3525 17.6673 11.625 19.1911 11.625H20.334V9.105C20.0856 9.07275 19.1477 9 18.1572 9C16.0887 9 14.6197 10.2427 14.6197 12.525V14.625H12.334V17.625H14.6197V24H17.6673V17.625Z" fill="white"/>
                      </svg>                      
                    </a>
                  </li>
                  <li>
                    <a href="{{settingList?.data?.twitter}}" target="_blank">
                      <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="16.5" cy="16.5" r="16.15" stroke="white" style="stroke:white;stroke-opacity:1;" stroke-width="0.7"/>
                        <path d="M17.8255 15.4331L23.0124 9.5332H21.7832L17.2795 14.6559L13.6822 9.5332H9.5332L14.9729 17.2797L9.5332 23.4665H10.7625L15.5187 18.0568L19.3175 23.4665H23.4665L17.8251 15.4331H17.8255ZM16.1419 17.3478L15.5907 16.5765L11.2053 10.4387H13.0934L16.6323 15.3922L17.1834 16.1635L21.7837 22.6022H19.8959L16.1419 17.3482V17.3478Z" fill="white" style="fill:white;fill-opacity:1;"/>
                        </svg>
                                            
                    </a>
                  </li>
                  <li>
                    <a href="{{settingList?.data?.instagram}}"  target="_blank">
                      <svg width="33" height="33" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="16.334" cy="16" r="16" fill="#418940"/>
                        <path d="M16.334 9C18.2359 9 18.4732 9.007 19.2194 9.042C19.9649 9.077 20.4724 9.1939 20.919 9.3675C21.381 9.5453 21.7702 9.7861 22.1594 10.1746C22.5153 10.5245 22.7908 10.9478 22.9665 11.415C23.1394 11.8609 23.257 12.3691 23.292 13.1146C23.3249 13.8608 23.334 14.0981 23.334 16C23.334 17.9019 23.327 18.1392 23.292 18.8854C23.257 19.6309 23.1394 20.1384 22.9665 20.585C22.7913 21.0524 22.5158 21.4758 22.1594 21.8254C21.8094 22.1812 21.3861 22.4566 20.919 22.6325C20.4731 22.8054 19.9649 22.923 19.2194 22.958C18.4732 22.9909 18.2359 23 16.334 23C14.4321 23 14.1948 22.993 13.4486 22.958C12.7031 22.923 12.1956 22.8054 11.749 22.6325C11.2816 22.4571 10.8583 22.1817 10.5086 21.8254C10.1526 21.4755 9.87714 21.0522 9.70148 20.585C9.52788 20.1391 9.41098 19.6309 9.37598 18.8854C9.34308 18.1392 9.33398 17.9019 9.33398 16C9.33398 14.0981 9.34098 13.8608 9.37598 13.1146C9.41098 12.3684 9.52788 11.8616 9.70148 11.415C9.87665 10.9475 10.1521 10.5241 10.5086 10.1746C10.8584 9.81846 11.2817 9.54301 11.749 9.3675C12.1956 9.1939 12.7024 9.077 13.4486 9.042C14.1948 9.0091 14.4321 9 16.334 9ZM16.334 12.5C15.4057 12.5 14.5155 12.8687 13.8591 13.5251C13.2027 14.1815 12.834 15.0717 12.834 16C12.834 16.9283 13.2027 17.8185 13.8591 18.4749C14.5155 19.1313 15.4057 19.5 16.334 19.5C17.2622 19.5 18.1525 19.1313 18.8089 18.4749C19.4652 17.8185 19.834 16.9283 19.834 16C19.834 15.0717 19.4652 14.1815 18.8089 13.5251C18.1525 12.8687 17.2622 12.5 16.334 12.5ZM20.884 12.325C20.884 12.0929 20.7918 11.8704 20.6277 11.7063C20.4636 11.5422 20.241 11.45 20.009 11.45C19.7769 11.45 19.5544 11.5422 19.3903 11.7063C19.2262 11.8704 19.134 12.0929 19.134 12.325C19.134 12.5571 19.2262 12.7796 19.3903 12.9437C19.5544 13.1078 19.7769 13.2 20.009 13.2C20.241 13.2 20.4636 13.1078 20.6277 12.9437C20.7918 12.7796 20.884 12.5571 20.884 12.325ZM16.334 13.9C16.8909 13.9 17.4251 14.1212 17.8189 14.5151C18.2127 14.9089 18.434 15.443 18.434 16C18.434 16.557 18.2127 17.0911 17.8189 17.4849C17.4251 17.8788 16.8909 18.1 16.334 18.1C15.777 18.1 15.2429 17.8788 14.8491 17.4849C14.4552 17.0911 14.234 16.557 14.234 16C14.234 15.443 14.4552 14.9089 14.8491 14.5151C15.2429 14.1212 15.777 13.9 16.334 13.9Z" fill="white"/>
                      </svg>                      
                    </a>
                  </li>
                  <li>
                    <a href="{{settingList?.data?.tiktok}}"  target="_blank">
                      <svg width="33" height="33" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="16.334" cy="16" r="16" fill="#418940"/>
                        <path d="M20.6478 11.35C20.6478 11.35 21.0706 11.7667 20.6478 11.35C20.081 10.6997 19.7687 9.86453 19.7689 9H17.2071V19.3333C17.1873 19.8925 16.9524 20.4222 16.5519 20.8108C16.1514 21.1994 15.6164 21.4166 15.0597 21.4167C13.8825 21.4167 12.9041 20.45 12.9041 19.25C12.9041 17.8167 14.2804 16.7417 15.6981 17.1833V14.55C12.8378 14.1667 10.334 16.4 10.334 19.25C10.334 22.025 12.6223 24 15.0515 24C17.6548 24 19.7689 21.875 19.7689 19.25V14.0083C20.8078 14.7582 22.055 15.1605 23.334 15.1583V12.5833C23.334 12.5833 21.7753 12.6583 20.6478 11.35Z" fill="white"/>
                      </svg>                      
                    </a>
                  </li>
                  <li>
                    <a href="{{settingList?.data?.youtube}}"  target="_blank">
                      <svg width="33" height="33" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="16.334" cy="16" r="16" fill="#418940"/>
                        <path d="M12.1414 22.8193C11.7463 23.0465 11.3461 23.0595 10.9408 22.8581C10.5363 22.6574 10.334 22.3473 10.334 21.9278V11.0725C10.334 10.653 10.5363 10.3425 10.9408 10.1412C11.3461 9.94049 11.7463 9.95377 12.1414 10.181L21.8007 15.6087C22.1562 15.8184 22.334 16.1156 22.334 16.5001C22.334 16.8847 22.1562 17.1819 21.8007 17.3916L12.1414 22.8193Z" fill="white"/>
                      </svg>                      
                    </a>
                  </li>
                  <li>
                    <a href="{{settingList?.data?.linkedin}}"  target="_blank">
                      <svg width="33" height="33" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="16.334" cy="16" r="16" fill="#418940"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M14.5343 13.8783H17.1341V15.1733C17.5086 14.4285 18.469 13.7593 19.9117 13.7593C22.6774 13.7593 23.334 15.2419 23.334 17.9621V23H20.534V18.5816C20.534 17.0325 20.1595 16.1589 19.2061 16.1589C17.8838 16.1589 17.3343 17.1004 17.3343 18.5809V23H14.5343V13.8783ZM9.73298 22.881H12.533V13.7593H9.73298V22.881ZM12.9341 10.785C12.9342 11.0197 12.8876 11.2521 12.7972 11.4686C12.7067 11.6852 12.574 11.8816 12.407 12.0464C12.0685 12.3828 11.6103 12.5712 11.133 12.57C10.6566 12.5697 10.1994 12.3818 9.86038 12.0471C9.69393 11.8817 9.56175 11.6851 9.47142 11.4685C9.3811 11.2519 9.33439 11.0197 9.33398 10.785C9.33398 10.3111 9.52298 9.8575 9.86108 9.5229C10.1998 9.18771 10.6572 8.99979 11.1337 9C11.6111 9 12.0689 9.1883 12.407 9.5229C12.7444 9.8575 12.9341 10.3111 12.9341 10.785Z" fill="white"/>
                      </svg>                      
                    </a>
                  </li>
                </ul>
              </div>
            </div>
        </div>

      </div>
    </div>
  </header> 
 <router-outlet></router-outlet>
 
  <footer class="footer-wrapper margin-top-90 cf">
    <div class="official-partner-section">
      <div class="official-partner-title">
        <div class="container">
          <div class="official-partner">
            <h2>Official Partners</h2>
          </div>
        </div>
      </div>
      <div class="official-partner-logo">
         <div class="official-partner-logo-title-main">
          <div class="container">
            <div class="official-partner-title"><img src="assets/images/uptonsteel-logo.png" alt="uptonsteel-logo"></div>
          </div>
         </div>
         <div class="official-partner-logo-detail" *ngIf="sponsorsList?.sponsors?.length > 0">
            <ul>
              <ngx-slick-carousel class="carousel" slickModal="slick-carousel" [config]="slidepartnerConfig">
                <li ngxSlickItem *ngFor="let sponsor of sponsorsList?.sponsors">
                  <a href="{{sponsor?.url}}" target="_blank">
                    <img [src]="sponsor?.image">
                  </a>
                </li>
                <!-- <li ngxSlickItem><a href="#"><img src="assets/images/official-partner-logo2.png" alt="official-partner-logo"></a></li>
                <li ngxSlickItem><a href="#"><img src="assets/images/official-partner-logo3.png" alt="official-partner-logo"></a></li>
                <li ngxSlickItem><a href="#"><img src="assets/images/official-partner-logo4.png" alt="official-partner-logo"></a></li>
                <li ngxSlickItem><a href="#"><img src="assets/images/official-partner-logo5.png" alt="official-partner-logo"></a></li>
                <li ngxSlickItem><a href="#"><img src="assets/images/official-partner-logo6.png" alt="official-partner-logo"></a></li>
                <li ngxSlickItem><a href="#"><img src="assets/images/official-partner-logo7.png" alt="official-partner-logo"></a></li>
                <li ngxSlickItem><a href="#"><img src="assets/images/official-partner-logo8.png" alt="official-partner-logo"></a></li> -->
              </ngx-slick-carousel>
            </ul>
         </div>
      </div>
    </div>
    <div class="footer-social-icon-section">
      <div class="container">
        <div class="footer-social-icon-detail">
          <h4>Follow Us:</h4>
          <ul>
            <li>
              <a href="{{settingList?.data?.facebook}}" target="_blank">
                <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="16.4407" cy="16.7642" r="15.8" stroke="#418940" stroke-width="0.4"/>
                  <path d="M17.774 17.8892H17.274V18.3892V24.2642H15.2264V18.3892V17.8892H14.7264H12.9407V15.8892H14.7264H15.2264V15.3892V13.2892C15.2264 12.2591 15.5548 11.5181 16.0643 11.0329C16.5776 10.544 17.3284 10.2642 18.2639 10.2642C18.9104 10.2642 19.5312 10.2959 19.9407 10.3256V11.8892H19.2978C18.4778 11.8892 17.8829 12.0832 17.5518 12.5672C17.3967 12.7939 17.332 13.0415 17.3023 13.2622C17.274 13.4726 17.274 13.6915 17.274 13.8743L17.274 13.8892V15.3892V15.8892H17.774H19.7978L19.2899 17.8892H17.774Z" fill="#418940" stroke="#418940"/>
                </svg> 
              </a>
            </li>
            <li>
              <a href="{{settingList?.data?.twitter}}" target="_blank">
                <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                  
                  <circle cx="17" cy="17" r="16" stroke="#418940" style="stroke:#418940;stroke:color(display-p3 0.2549 0.5373 0.2510);stroke-opacity:1;" stroke-width="0.7"/>
                  <path d="M18.3957 15.8769L23.8557 9.6665H22.5617L17.821 15.0588L14.0344 9.6665H9.66699L15.393 17.8207L9.66699 24.3332H10.961L15.9675 18.6387L19.9663 24.3332H24.3337L18.3954 15.8769H18.3957ZM16.6235 17.8924L16.0433 17.0805L11.4271 10.6196H13.4146L17.1397 15.8338L17.7198 16.6458L22.5623 23.4234H20.5751L16.6235 17.8928V17.8924Z" fill="#418940" style="fill:#418940;fill:color(display-p3 0.2549 0.5373 0.2510);fill-opacity:1;"/>
                </svg>
                  
              </a>
            </li>
            <li>
              <a href="{{settingList?.data?.instagram}}" target="_blank">
                <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="16.4407" cy="16.7642" r="15.8" stroke="#418940" stroke-width="0.4"/>
                  <path d="M20.8461 10.5983L20.8445 10.5977C20.455 10.4463 20.0018 10.3384 19.3026 10.3056L20.8461 10.5983ZM20.8461 10.5983C21.2458 10.7521 21.5752 10.9556 21.9128 11.2926L21.9128 11.2926M20.8461 10.5983L21.9128 11.2926M21.9128 11.2926L21.9155 11.2953M21.9128 11.2926L21.9155 11.2953M21.9155 11.2953C22.2197 11.5943 22.455 11.956 22.6052 12.3552L22.6052 12.3552M21.9155 11.2953L22.6052 12.3552M22.6052 12.3552L22.607 12.3599M22.6052 12.3552L22.607 12.3599M22.607 12.3599C22.7579 12.7491 22.8663 13.2031 22.8992 13.9015M22.607 12.3599L22.8992 13.9015M22.6069 21.1686L22.6069 21.1686C22.758 20.7784 22.8664 20.3248 22.8992 19.6261L22.6069 21.1686ZM22.6069 21.1686L22.605 21.1737M22.6069 21.1686L22.605 21.1737M22.605 21.1737C22.4554 21.5727 22.2202 21.9342 21.916 22.2326L21.9159 22.2326M22.605 21.1737L21.9159 22.2326M21.9159 22.2326L21.9096 22.2389M21.9159 22.2326L21.9096 22.2389M21.9096 22.2389C21.6105 22.543 21.2487 22.7784 20.8495 22.9287L20.8495 22.9287M21.9096 22.2389L20.8495 22.9287M20.8495 22.9287L20.8449 22.9305M20.8495 22.9287L20.8449 22.9305M20.8449 22.9305C20.4557 23.0814 20.0017 23.1898 19.3033 23.2227M20.8449 22.9305L19.3033 23.2227M12.0362 22.9304L12.0362 22.9304C12.4264 23.0815 12.88 23.1899 13.5787 23.2227L12.0362 22.9304ZM12.0362 22.9304L12.0313 22.9285M12.0362 22.9304L12.0313 22.9285M12.0313 22.9285C11.6322 22.7788 11.2707 22.5435 10.9721 22.2393L10.9722 22.2393M12.0313 22.9285L10.9722 22.2393M10.9722 22.2393L10.9657 22.2329M10.9722 22.2393L10.9657 22.2329M10.9657 22.2329C10.6616 21.934 10.4263 21.5724 10.2762 21.1732L10.2762 21.1732M10.9657 22.2329L10.2762 21.1732M10.2762 21.1732L10.2741 21.1678M10.2762 21.1732L10.2741 21.1678M10.2741 21.1678C10.1229 20.7794 10.015 20.3257 9.98216 19.6268C9.94975 18.8918 9.94067 18.6624 9.94067 16.7642C9.94067 14.8641 9.94769 14.6363 9.98212 13.9022C10.0149 13.2024 10.1228 12.7498 10.2742 12.3603L10.2742 12.3603M10.2741 21.1678L10.2742 12.3603M10.2742 12.3603L10.2764 12.3546M10.2742 12.3603L10.2764 12.3546M10.2764 12.3546C10.4259 11.9556 10.6611 11.5941 10.9653 11.2958L10.9654 11.2958M10.2764 12.3546L10.9654 11.2958M10.9654 11.2958L10.972 11.2891M10.9654 11.2958L10.972 11.2891M10.972 11.2891C11.2708 10.9849 11.6323 10.7496 12.0315 10.5997L12.0315 10.5998M10.972 11.2891L12.0315 10.5998M12.0315 10.5998L12.0368 10.5977M12.0315 10.5998L12.0368 10.5977M12.0368 10.5977C12.4262 10.4463 12.8786 10.3385 13.578 10.3056C14.313 10.2732 14.5425 10.2642 16.4407 10.2642C18.3408 10.2642 18.5686 10.2712 19.3026 10.3056L12.0368 10.5977ZM22.8992 13.9015C22.9316 14.6365 22.9407 14.866 22.9407 16.7642C22.9407 18.6642 22.9337 18.892 22.8992 19.6261L22.8992 13.9015ZM19.3033 23.2227C18.5683 23.2551 18.3389 23.2642 16.4407 23.2642C14.5406 23.2642 14.3128 23.2571 13.5787 23.2227L19.3033 23.2227ZM16.4407 12.7642C15.3798 12.7642 14.3624 13.1856 13.6122 13.9357C12.8621 14.6859 12.4407 15.7033 12.4407 16.7642C12.4407 17.825 12.8621 18.8424 13.6122 19.5926C14.3624 20.3427 15.3798 20.7642 16.4407 20.7642C17.5015 20.7642 18.519 20.3427 19.2691 19.5926C20.0192 18.8424 20.4407 17.825 20.4407 16.7642C20.4407 15.9025 20.1627 15.0696 19.6563 14.3852C19.8025 14.437 19.9577 14.4642 20.1157 14.4642C20.4803 14.4642 20.8301 14.3193 21.0879 14.0614C21.3458 13.8036 21.4907 13.4538 21.4907 13.0892C21.4907 12.7245 21.3458 12.3748 21.0879 12.1169C20.8301 11.859 20.4803 11.7142 20.1157 11.7142C19.751 11.7142 19.4013 11.859 19.1434 12.1169C18.8855 12.3748 18.7407 12.7245 18.7407 13.0892C18.7407 13.2472 18.7679 13.4024 18.8197 13.5485C18.1353 13.0422 17.3023 12.7642 16.4407 12.7642ZM16.4407 15.1642C16.865 15.1642 17.272 15.3327 17.572 15.6328C17.8721 15.9328 18.0407 16.3398 18.0407 16.7642C18.0407 17.1885 17.8721 17.5955 17.572 17.8955C17.272 18.1956 16.865 18.3642 16.4407 18.3642C16.0163 18.3642 15.6094 18.1956 15.3093 17.8955C15.0092 17.5955 14.8407 17.1885 14.8407 16.7642C14.8407 16.3398 15.0092 15.9328 15.3093 15.6328C15.6094 15.3327 16.0163 15.1642 16.4407 15.1642Z" fill="#418940" stroke="#418940"/>
                </svg>  
              </a>
            </li>
            <li>
              <a href="{{settingList?.data?.tiktok}}" target="_blank">
                <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="16.4407" cy="16.7642" r="15.8" stroke="#418940" stroke-width="0.4"/>
                  <path d="M22.9407 13.8157V15.4009C21.9442 15.3129 20.986 14.9574 20.1683 14.3671L19.3756 13.7949V14.7725V20.0142C19.3756 22.366 17.4823 24.2642 15.1581 24.2642C12.9856 24.2642 10.9407 22.4939 10.9407 20.0142C10.9407 17.6084 12.9334 15.6963 15.3048 15.7736V17.3508C13.8068 17.2629 12.5108 18.4754 12.5108 20.0142C12.5108 21.4904 13.7131 22.6808 15.1664 22.6808H15.1665C15.8535 22.6807 16.5132 22.4126 17.0068 21.9338C17.5002 21.455 17.7891 20.803 17.8134 20.1151L17.8138 20.1063V20.0975V10.2642H19.4062C19.5051 11.0672 19.8411 11.8267 20.3767 12.4417C21.021 13.1888 21.7886 13.54 22.3888 13.7038C22.5947 13.76 22.7823 13.7946 22.9407 13.8157Z" fill="#418940" stroke="#418940"/>
                </svg>                  
              </a>
            </li>
            <li>
              <a href="{{settingList?.data?.youtube}}" target="_blank">
                <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="16.4407" cy="16.7642" r="15.8" stroke="#418940" stroke-width="0.4"/>
                  <g clip-path="url(#clip0_1421_17330)">
                  <path d="M16.4917 10.7632H16.5807C17.4027 10.7662 21.5677 10.7962 22.6907 11.0982C23.0302 11.1904 23.3395 11.37 23.5878 11.6192C23.8361 11.8684 24.0147 12.1784 24.1057 12.5182C24.2067 12.8982 24.2777 13.4012 24.3257 13.9202L24.3357 14.0242L24.3577 14.2842L24.3657 14.3882C24.4307 15.3022 24.4387 16.1582 24.4397 16.3452V16.4202C24.4387 16.6142 24.4297 17.5282 24.3577 18.4802L24.3497 18.5852L24.3407 18.6892C24.2907 19.2612 24.2167 19.8292 24.1057 20.2472C24.015 20.5871 23.8365 20.8973 23.5882 21.1465C23.3398 21.3957 23.0303 21.5753 22.6907 21.6672C21.5307 21.9792 17.1217 22.0012 16.5107 22.0022H16.3687C16.0597 22.0022 14.7817 21.9962 13.4417 21.9502L13.2717 21.9442L13.1847 21.9402L13.0137 21.9332L12.8427 21.9262C11.7327 21.8772 10.6757 21.7982 10.1887 21.6662C9.84916 21.5744 9.53974 21.395 9.2914 21.1459C9.04306 20.8969 8.86452 20.587 8.77367 20.2472C8.66267 19.8302 8.58867 19.2612 8.53867 18.6892L8.53067 18.5842L8.52267 18.4802C8.47332 17.8026 8.44597 17.1236 8.44067 16.4442L8.44067 16.3212C8.44267 16.1062 8.45067 15.3632 8.50467 14.5432L8.51167 14.4402L8.51467 14.3882L8.52267 14.2842L8.54467 14.0242L8.55467 13.9202C8.60267 13.4012 8.67367 12.8972 8.77467 12.5182C8.86537 12.1782 9.04384 11.8681 9.29219 11.6189C9.54054 11.3696 9.85004 11.1901 10.1897 11.0982C10.6767 10.9682 11.7337 10.8882 12.8437 10.8382L13.0137 10.8312L13.1857 10.8252L13.2717 10.8222L13.4427 10.8152C14.3944 10.7846 15.3465 10.7676 16.2987 10.7642H16.4917V10.7632ZM14.8407 13.9732V18.7912L18.9977 16.3832L14.8407 13.9732Z" fill="#418940"/>
                  </g>
                  <defs>
                  <clipPath id="clip0_1421_17330">
                  <rect width="16" height="16" fill="white" transform="translate(8.44067 8.76416)"/>
                  </clipPath>
                  </defs>
                </svg>                  
              </a>
            </li>
            <li>
              <a href="{{settingList?.data?.linkedin}}" target="_blank">
                <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="16.4407" cy="16.7642" r="15.8" stroke="#418940" stroke-width="0.4"/>
                  <path d="M12.5408 11.5494V11.5492C12.5408 11.2094 12.4049 10.8835 12.1618 10.6423C11.9175 10.4006 11.5862 10.2642 11.2404 10.2642H11.2402C10.8954 10.264 10.5645 10.4 10.3195 10.6424L12.5408 11.5494ZM12.5408 11.5494C12.5408 11.7178 12.5074 11.8846 12.4425 12.04C12.3776 12.1954 12.2824 12.3364 12.1625 12.4547L12.1625 12.4547M12.5408 11.5494L12.1625 12.4547M12.1625 12.4547L12.1612 12.4559M12.1625 12.4547L12.1612 12.4559M12.1612 12.4559C11.9167 12.699 11.5857 12.835 11.2409 12.8342L11.24 12.8342M12.1612 12.4559L11.24 12.8342M11.24 12.8342C10.8952 12.8339 10.5644 12.6981 10.319 12.456M11.24 12.8342L10.319 12.456M10.319 12.456C10.1994 12.3371 10.1045 12.1958 10.0396 12.0402C9.97463 11.8845 9.94102 11.7175 9.94067 11.5487C9.94079 11.2086 10.0763 10.8831 10.3195 10.6425L10.319 12.456ZM15.141 15.1425H16.7408V15.9375L17.6875 16.1621C17.9622 15.6158 18.729 15.0235 20.0184 15.0235C21.3145 15.0235 21.9807 15.367 22.3604 15.8963C22.7714 16.4691 22.9407 17.378 22.9407 18.7263V23.2642H21.1407V19.3458C21.1407 18.549 21.0475 17.8448 20.7785 17.3241C20.6396 17.055 20.4475 16.8228 20.1881 16.6602C19.9275 16.4967 19.6301 16.4231 19.3128 16.4231C18.5177 16.4231 17.8865 16.7154 17.4752 17.2868C17.0848 17.8291 16.941 18.557 16.941 19.3451V23.2642H15.141V15.1425ZM12.1397 15.0235V23.1452H10.3397V15.0235H12.1397Z" fill="#418940" stroke="#418940"/>
                </svg>                  
              </a>
            </li>
          </ul>  
        </div>
      </div>
    </div>
    <div class="footer-menu-section">
      <div class="footer-menu-top">
         <div class="container">
            <div class="footer-menu-top-detail">
                <div class="footer-menu-top-list">
                  <ul>
                    <li><a href="https://www.leicestershireccc.co.uk/lccc-website/news" title="News">News </a></li>
                    <li><a href=" https://www.leicestershireccc.co.uk/contact" title="Contact">Contact Us</a></li>
                    <li><a href="https://goo.gl/maps/VfdF1yEYK1zEQQbh6" target="_blank" title="How to find us">How to find us</a></li>
                    <!-- <li><a href="https://www.leicestershireccc.co.uk/membership" title="Members">Members</a></li> -->
                    <!-- <li><a href="#" title="Match Center">Match Center</a></li> -->
                    <li><a href="https://www.leicestershireccc.co.uk/recruitment" title="Recruitment">Recruitment</a></li>
                    <li><a href="#" title="Accessibility">Accessibility</a></li>
                  </ul>
                </div>
                <div class="footer-menu-top-logo">
                   <ul>
                      <li><img src="assets/images/lccc-2020-transparent.png" alt="lccc-2020-transparent"></li>
                      <li><img src="assets/images/lccc_t20_all-white-transparent.png" alt="lccc_t20_all-white-transparent"></li>
                      <li><img src="assets/images/uptonsteel-arena-logo-v3-rev.png" alt="uptonsteel-arena-logo-v3-rev"></li>
                   </ul>
                </div>
                <div class="footer-menu-top-text">
                  <p>Uptonsteel County Ground, Grace Road, Leicester, Leicestershire, LE2 8EB</p>
                </div>
                <div class="footer-contact-list">
                   <ul>
                      <li class="phone-icon"><a href="tel:0116 283 2128" target="_blank">0116 283 2128 (Main Switchboard)</a></li>
                      <li class="phone-second-icon"><a href="tel:0116 2440363" target="_blank">0116 2440363</a></li>
                      <li class="mail-icon"><a href="mailto:enquiries@leicestershireccc.co.uk" target="_blank">enquiries@leicestershireccc.co.uk</a></li>
                   </ul>
                </div>
            </div>
         </div>
      </div>
      <div class="footer-menu-bottom">
        <div class="container">
          <div class="footer-menu-bottom-detail">
            <div class="footer-menu-bottom-left">
              <ul>
                <li><a href="/terms-of-use" title="terms of use">Terms of Use</a></li>
                <li><a href="/privacy" title="privacy">Privacy</a></li>
                <li><a href="/cookies" title="cookies">Cookies</a></li>     
              </ul>
            </div>
            <div class="footer-menu-bottom-center">
              <p>© 2024 by Leicestershire County Cricket Club. All Rights Reserved.</p>
            </div>
            <div class="footer-menu-bottom-right">
               <p>Powered by <a href="https://www.yellowpanther.io/" target="_blank" title="yellow panther">Yellow Panther</a></p>
            </div>
          </div>   
        </div>
      </div>
    </div>
  </footer> 
</section><!-- body ends-->
